if (process.env.NODE_ENV !== 'development') {
  module.exports = {
    ReactQueryDevtools: function () {
      return null
    },
    ReactQueryDevtoolsPanel: function () {
      return null
    },
  }
} else {
  module.exports = require('./development')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-query/devtools/index.js
// module id = 1694
// module chunks = 31